var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subwrap modulewrap"},[_c('div',{staticClass:"subbody realwrap"},[_c('Cmembernav',{attrs:{"curnavkv":_vm.curnavkv}}),_c('div',{staticClass:"meminfo"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }